import { render, staticRenderFns } from "./Authorizations.vue?vue&type=template&id=7086b038&scoped=true"
import script from "./Authorizations.vue?vue&type=script&lang=js"
export * from "./Authorizations.vue?vue&type=script&lang=js"
import style0 from "./Authorizations.vue?vue&type=style&index=0&id=7086b038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086b038",
  null
  
)

export default component.exports